import Image from "next/image";
import Head from "next/head";
import dynamic from "next/dynamic";
const GetInTouchForm = dynamic(() =>
  import("../../src/component/forms/GetInTouchForm")
);
const JoinOurTeam = dynamic(() =>
  import("../../src/component/cards/JoinOurTeamNew")
);
const HowItWorkCard = dynamic(() =>
  import("../../src/component/cards/HowItWorkCard")
);
import { useRouter } from "next/navigation";
import Header from "@/component/Header/NewHeader";
export function Subcard({ item }) {
  return (
    <div className="rounded-[10px] bg-[#fff]   p-6 flex md:flex-row flex-col justify-between items-center getstarted">
      <div className="flex flex-col">
        <span className="text-[16px] font-bold ml-[5px]">{item.title}</span>

        <span className="text-[10px] font-medium mt-[10px]">
          {item.description}
        </span>
      </div>
      <span
        // style={{ background: item.fill }}
        className="max-w-[64px] min-w-[64px] min-h-[64px] p-2 rounded-full flex flex-col justify-center items-center"
      >
        <div className="z-20 flex items-center order-1   border-1 border-[#111] shadow-xl w-8 h-8 rounded-full xl:mr-[30px] lg:mr-[30px] md:mr[30px] sm:mr-[30px]">
          <span className="mx-auto  font-semibold text-lg">{item.number}</span>
        </div>
      </span>
    </div>
  );
}

export default function UserBcaDetails({ details, BannerImage }) {
  const router = useRouter();
  const stakingApiList = [
    {
      icon: "market-graph",
      title: "Educational Documents",
      fill: "#0EE7B3",
      subtitle:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dui mi, bibendum eu erat id, ultricies semper metus. Nunc dapibus laoreet dolor nec imperdiet.",
    },
    {
      icon: "boost-icon",
      title: "Experience Certificates",
      fill: "#835AFE",
      subtitle:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dui mi, bibendum eu erat id, ultricies semper metus. Nunc dapibus laoreet dolor nec imperdiet.",
    },
    {
      icon: "reduce-grapg-icon",
      title: "Extra Degree Certificates",
      fill: "#F0AB36",
      subtitle:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dui mi, bibendum eu erat id, ultricies semper metus. Nunc dapibus laoreet dolor nec imperdiet.",
    },
    {
      icon: "residence",
      title: "Residential Address",
      fill: "#F0AB36",
      subtitle:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dui mi, bibendum eu erat id, ultricies semper metus. Nunc dapibus laoreet dolor nec imperdiet.",
    },
    {
      icon: "criminal-records",
      title: "Criminal Records",
      fill: "#F0AB36",
      subtitle:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dui mi, bibendum eu erat id, ultricies semper metus. Nunc dapibus laoreet dolor nec imperdiet.",
    },
    {
      icon: "identity-check",
      title: "Criminal Records",
      fill: "#F0AB36",
      subtitle:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dui mi, bibendum eu erat id, ultricies semper metus. Nunc dapibus laoreet dolor nec imperdiet.",
    },
  ];

  return (
    <>
      <Head>
        <title>BCA Verification Details | Background Verification Software India | CoinCircleTrust</title>
        <meta name="description" content="Detailed view of background check agency (BCA) verification processes and document requirements." />
      </Head>
      <Header />
      <div className="bg-[#FFF]">
        {details?.slug === "bca" ? (
          <div
            className=" flex justify-between item-center banner1 max-sm:!h-[600px] relative overflow-hidden"
            style={{ backgroundImage: "/images/Vector-min.png" }}
          >
            <div
              className="grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-4 container-padding-x lg:py-[60px] py-[30px]"
              style={{
                backgroundImage: "url('/images/Vector-min.png')",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="lg:my-[35px]">
                <h1 className="capitalize xl:text-[40px] lg:text-[40px] md:text-[40px] text-[40px] lg:my-[30px] my-[20px] leading-[50px] text-[#fff] font-bold">
                  {details?.Banner?.title}
                </h1>
                <p className="text-[20px] text-[#fff] mb-[24px] capitalize font-thin">
                  {details?.Banner?.subtitle}
                </p>
                <button
                  className="w-[200px] py-[14px] mt-[40px] text-white flex justify-center items-center text-[14px] cursor-pointer rounded-l-lg rounded-r-lg font-semibold"
                  type="button"
                  onClick={() => router.push(details?.Banner?.Button?.path)}
                  style={{
                    background:
                      "linear-gradient(94deg, #004B96 2.63%, #0DEAB3 162.7%)",
                    border: "2px solid #FFF",
                    borderRadius: "10px",
                  }}
                >
                  {details?.Banner?.Button?.name}
                </button>
              </div>
              <div className="z-10 hidden 2xl:block">
                <Image
                  // eslint-disable-next-line no-undef
                  src={BannerImage}
                  alt="banner-img"
                  width={1200}
                  height={550}
                  zindex="1"
                  className="mt-[30px]"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-between items-center banner1 max-[769px]:h-[500px] relative overflow-hidden">
            <div className="lg:pt-[60px] lg:my-[35px] container-padding-x">
              <h1 className="capitalize xl:text-[40px] lg:text-[40px] md:text-[40px] text-[40px] lg:my-[30px]  leading-[50px] xl:w-[175%] lg:w-[150%] text-[#fff] font-bold">
                {details?.Banner?.title}
              </h1>
              <p className="text-[20px] text-[#fff] mb-[24px]  font-thin xl:w-[150%] lg:w-[150%]">
                {details?.Banner?.subtitle}
              </p>
              <button
                className="w-[200px] py-[14px] mt-[40px] text-white flex justify-center items-center text-[14px] cursor-pointer rounded-l-lg rounded-r-lg font-semibold"
                type="button"
                onClick={() => router.push(details?.Banner?.Button?.path)}
                style={{
                  background:
                    "linear-gradient(94deg, #004B96 2.63%, #0DEAB3 162.7%)",
                  border: "2px solid #FFF",
                  borderRadius: "10px",
                }}
              >
                {details?.Banner?.Button?.name}
              </button>
            </div>
            <div className="hidden xl:block lg:block pt-4">
              <Image
                src={BannerImage}
                alt="banner-img"
                width={3500}
                height={700}
                className="h-[700px] lg:h-[600px] w-[3500px]"
              />
            </div>
          </div>
        )}

        <section className=" mt-[40px]">
          <div
            className="flex flex-col container-padding-x md:py-[70px] py-[40px] mb-[80px]"
            style={{
              backgroundPosition: "left",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="flex flex-col">
              <p
                className="text-center text-[14px] text-[#8A898E]"
                style={{ "letter-spacing": "6.3px" }}
              >
                {details?.HowWeCanHelpYou?.title}
              </p>
              <h2 className="text-[#004B96] text-center md:text-[40px] text-[50px]  max-[426px]:text-[24px] font-bold">
                {details?.HowWeCanHelpYou?.subtitle.split(" ")[0]}{" "}
                {details?.HowWeCanHelpYou?.subtitle.split(" ")[1]}{" "}
                {details?.HowWeCanHelpYou?.subtitle.split(" ")[2]}{" "}
                <span className="text-[#0DEAB3]">
                  {details?.HowWeCanHelpYou?.subtitle.split(" ")[3]}{" "}
                  {details?.HowWeCanHelpYou?.subtitle.split(" ")[4]}{" "}
                </span>
              </h2>
              <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 mt-[40px] gap-6">
                {details?.HowWeCanHelpYou?.Services &&
                  details?.HowWeCanHelpYou?.Services.length &&
                  details?.HowWeCanHelpYou?.Services.map((item, index) => {
                    // console.log("stakingApiList", item);
                    return (
                      <HowItWorkCard
                        key={item.title}
                        item={item}
                        index={index}
                        stakingApiList={stakingApiList}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </section>

        <section className="section-bg mt-[40px]">
          <div
            className="container-padding-x"
            style={{
              backgroundImage: "url('/images/Vector-min.png')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="flex justify-center items-center md:py-[70px] py-[40px] px-[100px] mb-[80px]">
              <div className="rounded-[20px] bg-[#fff] py-[60px] min-w-[300px] max-w-[600px] relative">
                <h2 className="text-[#004B96] text-center max-[768px]:text-[38px] max-[425px]:text-[26px] text-[40px] font-bold">
                  {details?.GetStarted?.title.split(" ")[0]}{" "}
                  {details?.GetStarted?.title.split(" ")[1]}{" "}
                  <span className="text-[#0DEAB3]">
                    {details?.GetStarted?.title.split(" ")[2]}{" "}
                  </span>
                </h2>
                <p className="text-center text-[14px] text-[#8A898E] pt-[10px] pb-[30px] max-sm:px-2">
                  {" "}
                  {details?.GetStarted?.subtitle}
                </p>
                <div className="grid grid-rows mt-[10px] px-[40px]">
                  {details?.GetStarted?.InnerCard &&
                    details?.GetStarted?.InnerCard.length &&
                    details?.GetStarted?.InnerCard.map((item) => {
                      return (
                        <>
                          <div
                            className="flex flex-col bg-[#fff] border-2 shadow-xl xl:mt-[0px] mb-[20px] cursor-pointer"
                            style={{ borderRadius: "10px" }}
                          >
                            <Subcard item={item} key={item?.title} />
                          </div>
                        </>
                      );
                    })}
                </div>
                <span className="absolute right-[-30px] top-[-65px] max-[425px]:top-[-75px]">
                  <Image
                    // eslint-disable-next-line no-undef
                    src="/images/Slang-To-the-Moon--cryptocurrency-crypto-web 3.png"
                    alt="banner-img"
                    width="110"
                    height="110"
                    zindex="1"
                    className="mt-[30px]"
                  />
                </span>
              </div>
            </div>
          </div>
        </section>

        <div className="container-padding-x pb-[100px]">
          <GetInTouchForm />
        </div>

        <div className="container-padding-x pb-[50px]">
          {/* <JoinOurTeam /> */}
        </div>
      </div>
    </>
  );
}
